// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__35tVg","label":"Labeled_label__2G4vc","divider":"Labeled_divider__2m9so"};